/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MoveJobRequest model module.
 * @module model/MoveJobRequest
 * @version V1
 */
class MoveJobRequest {
    /**
     * Constructs a new <code>MoveJobRequest</code>.
     * @alias module:model/MoveJobRequest
     * @param jobId {Number} 
     * @param newStatusId {Number} 
     */
    constructor(jobId, newStatusId) { 
        
        MoveJobRequest.initialize(this, jobId, newStatusId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, jobId, newStatusId) { 
        obj['jobId'] = jobId;
        obj['newStatusId'] = newStatusId;
    }

    /**
     * Constructs a <code>MoveJobRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MoveJobRequest} obj Optional instance to populate.
     * @return {module:model/MoveJobRequest} The populated <code>MoveJobRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MoveJobRequest();

            if (data.hasOwnProperty('jobId')) {
                obj['jobId'] = ApiClient.convertToType(data['jobId'], 'Number');
            }
            if (data.hasOwnProperty('newStatusId')) {
                obj['newStatusId'] = ApiClient.convertToType(data['newStatusId'], 'Number');
            }
            if (data.hasOwnProperty('insertAfterPosition')) {
                obj['insertAfterPosition'] = ApiClient.convertToType(data['insertAfterPosition'], 'String');
            }
            if (data.hasOwnProperty('insertBeforePosition')) {
                obj['insertBeforePosition'] = ApiClient.convertToType(data['insertBeforePosition'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MoveJobRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MoveJobRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MoveJobRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['insertAfterPosition'] && !(typeof data['insertAfterPosition'] === 'string' || data['insertAfterPosition'] instanceof String)) {
            throw new Error("Expected the field `insertAfterPosition` to be a primitive type in the JSON string but got " + data['insertAfterPosition']);
        }
        // ensure the json data is a string
        if (data['insertBeforePosition'] && !(typeof data['insertBeforePosition'] === 'string' || data['insertBeforePosition'] instanceof String)) {
            throw new Error("Expected the field `insertBeforePosition` to be a primitive type in the JSON string but got " + data['insertBeforePosition']);
        }

        return true;
    }


}

MoveJobRequest.RequiredProperties = ["jobId", "newStatusId"];

/**
 * @member {Number} jobId
 */
MoveJobRequest.prototype['jobId'] = undefined;

/**
 * @member {Number} newStatusId
 */
MoveJobRequest.prototype['newStatusId'] = undefined;

/**
 * @member {String} insertAfterPosition
 */
MoveJobRequest.prototype['insertAfterPosition'] = undefined;

/**
 * @member {String} insertBeforePosition
 */
MoveJobRequest.prototype['insertBeforePosition'] = undefined;






export default MoveJobRequest;

